import React from "react";

export default function ArticleCredits({
    lines = [],                // array of strings, one per credit line
    dividerWidth = "w-24",     // e.g., w-16 / w-24 / w-40
    dividerClass = "bg-blue-600",
    padY = "py-16",
    padX = "px-6 sm:px-12",
    containerWidth = "max-w-lg",
}) {
    return (
        <section className={`w-full bg-white ${padY} ${padX}`}>
            <div className={`${containerWidth} mx-auto text-center`}>
                {/* thin centered divider */}
                <div className={`h-[2px] ${dividerWidth} ${dividerClass} mx-auto mb-8`} />
                {/* credits */}
                <div className="text-gray-500 italic text-sm leading-relaxed space-y-2">
                    {lines.map((line, i) => (
                        <p key={i}>{line}</p>
                    ))}
                </div>
            </div>
        </section>
    );
}
